import axios from 'axios';

export default {
  get({ id, ...parameters }) {
    return axios.get(`/applications/${id}/history`, { params: parameters });
  },
};
